import { connectToStores } from 'fluxible-addons-react';
import { QUANTUM_UI } from '../../../../flags';
import NavigationStore from '../../../stores/NavigationStore';
import QuickstartStore from '../../../stores/QuickstartStore';
import UserStore from '../../../stores/UserStore';
import { HomePage } from './HomePage';
import { HomePage as HomePageOld } from './HomePage.old';
export default connectToStores(QUANTUM_UI ? HomePage : HomePageOld, [NavigationStore, QuickstartStore], function (context) { return ({
    isAuthenticated: context.getStore(UserStore).isAuthenticated(),
    quickstarts: context.getStore(QuickstartStore).getQuickstarts(),
    cards: context.getStore(NavigationStore).getCards(),
}); });
